import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { LOGOUT, LOGOUT_SUCCESS, LogoutSuccessAction } from './auth.actions';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { ConfigService } from '../../config/config.service';
import { redirectToAuthServer } from '../../../../old-crazy-web-frontend/src/app/auth/auth.service';

@Injectable()
export class AuthEffects {
  @Effect() logout$: Observable<Action> = this.actions$.ofType(LOGOUT).map(() => new LogoutSuccessAction());

  @Effect({ dispatch: false })
  logoutSuccess$: Observable<Action> = this.actions$.ofType(LOGOUT_SUCCESS).do(() => {
    const AUTHENTICATION_SERVER = this.configService.getValue('AUTHENTICATION_SERVER');
    window.location.href = redirectToAuthServer(AUTHENTICATION_SERVER, '/logout');
  });

  constructor(private actions$: Actions, private configService: ConfigService) {}
}
